<script>
export default {
  name: 'ItineraryPricesPriceSettingTableActions',
  props: {
    extras: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedExtra: null,
    };
  },
  methods: {
    setExtra(value) {
      this.$emit('set-extra', value);
      this.$nextTick(() => {
        this.selectedExtra = null;
      });
    },
  },
};
</script>

<template>
  <v-layout row mt-4>
    <v-flex xs1>
      <v-btn color="primary" @click="$emit('add-hotel')">
        Add hotel
      </v-btn>
    </v-flex>
  </v-layout>
</template>



// WEBPACK FOOTER //
// src/components/itinerary/itineraryPrices/ItineraryPricesPriceSettingTableActions.vue